<script setup>
import { ref, computed, onMounted } from 'vue';
import MobileLineBar from '@/components/mobile/MobileLineBar.vue';
import MStateBox from '@/rebuild/components/MStateBox.vue';
import { useMainBusinessData } from './useMainBusinessData';
import MobileDropdown from './MobileDropdown.vue';
// import { MiniTable, MiniTableColumn } from '@/rebuild/components/table';
const props = defineProps({
	item: {
		type: Object,
		required: true
	},

	isOverview: {
		type: Boolean,
		default: false
	}
});

const { loadData, getDataFunc } = useMainBusinessData();
const activeScale = ref(2);
const activeDate = ref(5);
const activePeriod = ref('A');

const wrapLoading = ref(false);
const resData = ref([]);
const getChatOriginData = computed(() => (resData.value || []).sort((a, b) => a.reportDate - b.reportDate));
const wrapEmpty = computed(() => getChatOriginData.value.length === 0 && !wrapLoading.value);

async function refresh() {
	wrapLoading.value = true;
	const res = await loadData({
		classifCd: props.item.classifCd,
		reportType: activePeriod.value
	});
	resData.value = res;
	console.log('🚀 ~ refresh ~ resData:', resData);
	initData();
	wrapLoading.value = false;
}
onMounted(() => {
	refresh();
});

const chartData = ref({ seriesData: [] });
const tableData = ref([]);
const dynamicColumns = ref([]);

function initData() {
	console.log(getChatOriginData.value, resData.value, activeDate.value, activePeriod.value);
	const { chartOptions, tableOptions } = getDataFunc({
		list: resData.value,
		type: activeScale.value,
		timeType: activeDate.value,
		period: activePeriod.value,
		isMobile: true
	});
	chartData.value = chartOptions || { seriesData: [] };
	console.log('🚀 ~ initData ~ chartData.value:', chartData.value);
	tableData.value = tableOptions.data || [];
	dynamicColumns.value = tableOptions.columns || [];
}
</script>

<template>
	<div class="main-business__mobile">
		<div v-if="!isOverview" class="tabs-selects">
			<div class="block">
				<p class="title">{{ props.item.name }}</p>
			</div>
			<MobileDropdown
				:activeDate.sync="activeDate"
				:activePeriod.sync="activePeriod"
				:activeScale.sync="activeScale"
				@scaleChange="initData"
				@dateChange="initData"
				@periodChange="refresh"
			/>
		</div>
		<div class="chart-wrapper">
			<MStateBox :loading="wrapLoading" :empty="wrapEmpty" class="chart-wrapper-box">
				<MobileLineBar v-bind="chartData" class="chart-wrapper-box-chart" />
				<!-- <MiniTable :data="tableData" class="chart-wrapper-box-table">
					<MiniTableColumn prop="name" width="90" />
					<MiniTableColumn :label="item" :prop="item" v-for="item in dynamicColumns" :key="item" width="90"
				/></MiniTable> -->
			</MStateBox>
		</div>
	</div>
</template>

<style lang="less">
.main-business__mobile {
	min-height: 120px;
	.tabs-selects {
		display: flex;
		align-items: center;
		justify-content: space-between;
		.title {
			color: var(--emphasis-color);
			font-size: 16px;
			font-weight: 600;
			line-height: 24px;
		}
	}
	.chart-wrapper {
		width: 100%;
		// height: 256px;

		.chart-wrapper-box {
			height: 100%;
			&-chart {
				height: 256px;
			}
			&-table {
				margin-top: 20px;
			}
		}
	}
	.tabs-selects + .chart-wrapper {
		margin-top: 16px;
	}
}
.compare-select-popover {
	width: 88px;

	.el-select-dropdown__item {
		padding: 0 12px !important;
	}
	.popper__arrow {
		display: none;
	}
}
</style>
